import Vue from 'vue'
import GoogleAnalytics from 'vue-analytics'
import router from '@/router/index'

Vue.use(GoogleAnalytics, {
  id: 'UA-143774896-1',
  checkDuplicatedScript: true,
  router,
  autoTracking: {
    exeption: true
  },
  debug: {
    enabled: !process.env.VUE_APP_isPROD,
    sendHitTask: process.env.VUE_APP_isPROD
  }
})